import { render, staticRenderFns } from "./modal.vue?vue&type=template&id=0af5f19e&lang=html&"
import script from "./modal.vue?vue&type=script&lang=js&"
export * from "./modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Devdoc\\_packages\\moss-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0af5f19e')) {
      api.createRecord('0af5f19e', component.options)
    } else {
      api.reload('0af5f19e', component.options)
    }
    module.hot.accept("./modal.vue?vue&type=template&id=0af5f19e&lang=html&", function () {
      api.rerender('0af5f19e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/modal.vue"
export default component.exports